var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"process"},[(_vm.isSale)?_c('Merchandising'):_vm._e(),_c('Sections'),_c('Production')],1)}
var staticRenderFns = []

export { render, staticRenderFns }